export const API_NAME = '/rent-saas'

export let HOST = window.location.origin + API_NAME;
export const employeeId = 1;

/**
 * @description: 登录
 */
export const API_open_home_checkVerifyCode = HOST + '/open/home/checkVerifyCode'; //短信验证码校验
export const API_open_home_resetPasswordEmployee = HOST + '/open/home/resetPasswordEmployee'; //忘记密码 --重置密码-employee#平台人员
export const API_open_home_resetPasswordMerchantUser = HOST + '/open/home/resetPasswordMerchantUser'; //忘记密码 --重置密码-MerchantUser#商户人员
export const API_open_home_sendVerifyCode = HOST + '/open/home/sendVerifyCode'; //发送短信验证码
export const API_open_home_login_plateform = HOST + '/open/home/login_plateform'; //平台登录
export const API_open_home_login_merchant = HOST + '/open/home/login_merchant'; //商户登录

/**
 * @description: 账单控制层
 * 分页；总数/总金额（提醒）；账单列表信息（提醒）；发送催收短信；导出；账单总条数（总金额），账单列表，账单详情, 退款账单详情
 */
export const API_bill_findPage = HOST + '/platform/bill/findPage';
export const API_bill_findBillRemindCount = HOST + '/platform/bill/findBillRemindCount';
export const API_bill_findBillRemindPageList = HOST + '/platform/bill/findBillRemindPageList';
export const API_bill_billSmsSendNotice = HOST + '/platform/bill/billSmsSendNotice';
export const API_bill_billExprotDate = HOST + '/platform/bill/billExprotDate';
export const API_bill_findBillCount = HOST + '/platform/bill/findBillCount';
export const API_bill_findBillPageList = HOST + '/platform/bill/findBillPageList';
export const API_bill_findReceivingReportPageList = HOST + '/platform/bill/findReceivingReportPageList';
export const API_bill_findReceivingReportCount = HOST + '/platform/bill/findReceivingReportCount';
export const API_bill_findPrintReceiptPageList=HOST +'/platform/bill/findPrintReceiptPageList';
export const API_bill_findBillList = HOST + '/platform/bill/findBillList';
export const API_bill_getBillById = HOST + '/platform/bill/getBillById';
export const API_Bill_findPrintReceiptListByCustomerId=   HOST + '/platform/bill/findPrintReceiptListByCustomerId';
export const API_bill_findBillEndPageList = HOST + '/platform/bill/findBillEndPageList';
export const API_bill_findBillEndById = HOST + '/platform/bill/findBillEndById';
export const API_bill_deletedBill = HOST + '/platform/bill/deletedBill';
export const API_bill_edit = HOST + '/platform/bill/edit';
export const API_bill_getPayableVo = HOST + '/platform/bill/getPayableVo';
export const API_bill_payOtherBill = HOST + '/platform/bill/payOtherBill';
export const API_bill_payOffline = HOST + '/platform/bill/payOffline';
export const API_bill_addManual = HOST + '/platform/bill/addManual';
export const API_bill_billEndExprotDate = HOST + '/platform/bill/billEndExprotDate';  //退款账单导出
export const API_bill_collectionBillExprotDate = HOST + '/platform/bill/collectionBillExprotDate';//收款账单导出
export const API_bill_collectionReceivingReportExprotDate = HOST + '/platform/bill/collectionReceivingReportExprotDate';//收款账单报表导出
export const API_bill_importBill = HOST + '/platform/bill/importBill';//合同账单上传
export const API_bill_billImportTemplate = HOST + '/platform/rentcontract/getImportBillTemplate';//账单模板下载
export const API_bill_getImportLog = HOST + '/platform/bill/getImportLog';//获取批量导入合同账单的异步进程日志
export const API_device_importBill = HOST + '/platform/device/importBill';//合同账单上传
export const API_device_importAcceptanceDate = HOST + '/platform/device/importAcceptanceDate';//合同账单上传


export const API_device_getImportLog = HOST + '/platform/device/getImportLog';//获取批量导入合同账单的异步进程日志


/**
 * @description: 房源控制层
 * 不分页；分页；获取单条；创建；编辑；停用；删除；导出；导入；导入模板；房源签约列表；
 */
export const API_house_findHousePageList = HOST + '/platform/house/findHousePageList';
export const API_house_findPage = HOST + '/platform/house/findPage';
export const API_house_getHouseById = HOST + '/platform/house/getHouseById';
export const API_house_create = HOST + '/platform/house/create';
export const API_house_edit = HOST + '/platform/house/edit';
export const API_house_stopHouse = HOST + '/platform/house/stopHouse';
export const API_house_deleteHouse = HOST + '/platform/house/deleteHouse';
export const API_house_houseExprotDate = HOST + '/platform/house/houseExprotDate';
export const API_house_houseImportData = HOST + '/platform/house/houseImportData';
export const API_house_houseImportTemplate = HOST + '/platform/house/houseImportTemplate';
export const API_house_findHouseRentPage = HOST + '/platform/house/findHouseRentPage';
export const API_house_houseRentExprotDate = HOST + '/platform/house/houseRentExprotDate';
export const API_house_exportContractTemplate = HOST + '/platform/house/getImportContractTemplate';

export const API_roomType_findRoomDevicePageList = HOST + '/platform/roomType/findRoomDevicePageList';
export const API_roomType_downloadImages = HOST + '/platform/roomType/downloadImages';
export const API_roomType_findDeviceRepairReportPageList = HOST + '/platform/roomType/findDeviceRepairReportPageList';

export const API_house_findHouseBillPageList = HOST + '/platform/house/findHouseBillPageList';
export const API_house_findHouseBillCount = HOST + '/platform/house/findHouseBillCount';

export const API_device_findDeviceBillWriteOffPage = HOST + '/platform/device/findDeviceBillWriteOffPage';


//


/**
 * @description: 户型控制层
 * 分页；获取单条；创建；编辑；删除；
 */
export const API_houselayout_findPage = HOST + '/platform/houselayout/findPage';
export const API_houselayout_getById = HOST + '/platform/houselayout/getById';
export const API_houselayout_create = HOST + '/platform/houselayout/create';
export const API_houselayout_edit = HOST + '/platform/houselayout/edit';
export const API_houselayout_deleteHouseLayout = HOST + '/platform/houselayout/deleteHouseLayout';

export const API_category_device_deleteDeviceLayout = HOST + '/platform/roomType/deleteCategoryDevice';

/**
 * @description: 小区/楼栋控制层
 * 分页；获取单条；创建；编辑；删除；获取详情与户型信息；
 */
export const API_building_findBuildingPageList = HOST + '/platform/building/findBuildingPageList';
export const API_building_findBuildingList = HOST + '/platform/building/findBuildingList';
export const API_building_getById = HOST + '/platform/building/getById';
export const API_building_create = HOST + '/platform/building/create';
export const API_building_edit = HOST + '/platform/building/edit';
export const API_building_deleteBuilding = HOST + '/platform/building/deleteBuilding';
export const API_building_getBuildingById = HOST + '/platform/building/getBuildingById';
//修改收房合同
export  const API_building_editHousingContract =  HOST + '/platform/building/editHousingContract';
//删除收款合同收款账号配置
export const API_building_deletePayeeMerchant = HOST + '/platform/building/deletePayeeMerchant';
//删除收款合同租金周期配置
export const API_building_deleteRentCycle = HOST + '/platform/building/deleteRentCycle';

/**
 * @description: 租客（承租人）接口
 * 分页；单个实例；增；编辑；租客列表查询；租客信息（号码重复校验）
 */
export const API_customer_findCustomerPageList = HOST + '/platform/customer/findCustomerPageList';
export const API_customer_getById = HOST + '/platform/customer/getById';
export const API_customer_create = HOST + '/platform/customer/create';
export const API_customer_edit = HOST + '/platform/customer/edit';
export const API_customer_verifyCustomerPhone = HOST + '/platform/customer/verifyCustomerPhone';
export const API_customer_findOneByPhoneOrCredentialNumber = HOST + '/platform/customer/findOneByPhoneOrCredentialNumber';


/**
 *  优惠券相关功能
 */
export const API_coupon_findPageList = HOST + '/platform/coupon/findPage';
export const API_coupon_getById = HOST + '/platform/coupon/getById';
export const API_coupon_create = HOST + '/platform/coupon/create';
export const API_coupon_edit = HOST + '/platform/coupon/edit';
export const API_coupon_updateDiscountCouponStatus = HOST + '/platform/coupon/updateDiscountCouponStatus';
export const API_coupon_log_findPageList = HOST + '/platform/coupon/log/findPage';

/**
 * 威富通支付渠道
 */
export const API_wftPayChannel_findPageList = HOST + '/platform/wftPayChannelConfig/findPage';
export const API_wftPayChannel_findBuildingHouseList = HOST + '/platform/wftPayChannelConfig/findBuildingHouseList';
export const API_wftPayChannel_add = HOST + '/platform/wftPayChannelConfig/add';
export const API_wftPayChannel_update = HOST + '/platform/wftPayChannelConfig/update';
export const API_wftPayChannel_updateWftPayChannelConfigStatus = HOST + '/platform/wftPayChannelConfig/updateWftPayChannelConfigStatus';
export const API_wftPayChannel_getById = HOST + '/platform/wftPayChannelConfig/get';

/**
 * 惠市宝支付渠道
 */
export const API_hsbPayChannel_findPageList = HOST + '/platform/hsbPayChannelConfig/findPage';
export const API_hsbPayChannel_findBuildingHouseList = HOST + '/platform/hsbPayChannelConfig/findBuildingHouseList';
export const API_hsbPayChannel_add = HOST + '/platform/hsbPayChannelConfig/add';
export const API_hsbPayChannel_update = HOST + '/platform/hsbPayChannelConfig/update';
export const API_hsbPayChannel_updateHsbPayChannelConfigStatus = HOST + '/platform/hsbPayChannelConfig/updateHsbPayChannelConfigStatus';
export const API_hsbPayChannel_updateHsbPayChannelConfigClrgRuleStatus = HOST + '/platform/hsbPayChannelConfig/updateHsbPayChannelConfigClrgRuleStatus';

export const API_hsbPayChannel_getById = HOST + '/platform/hsbPayChannelConfig/get';

export const API_hsbPayChannel_getHsbPayChannelConfigClrgRuleById = HOST + '/platform/hsbPayChannelConfig/getHsbPayChannelConfigClrgRule';
export const API_hsbPayChannel_updateHsbPayChannelConfigClrgRule = HOST + '/platform/hsbPayChannelConfig/updateHsbPayChannelConfigClrgRule';
export const API_hsbPayChannel_addHsbPayChannelConfigClrgRule = HOST + '/platform/hsbPayChannelConfig/addHsbPayChannelConfigClrgRule';
export const API_hsbPayChannel_copyHsbPayChannelConfigClrgRule = HOST + '/platform/hsbPayChannelConfig/copyHsbPayChannelConfigClrgRule';
//
export const API_hsbPayChannel_findHsbPayChannelConfigClrgRulePage = HOST + '/platform/hsbPayChannelConfig/findHsbPayChannelConfigClrgRulepage';
export const API_hsbPayChannel_deletedHsbPayChannelConfigClrgRule = HOST + '/platform/hsbPayChannelConfig/deletedHsbPayChannelConfigClrgRule';

//威富通分账配置
export const API_wftPayChannel_findWftPayChannelConfigClrgRulePage = HOST + '/platform/wftPayChannelConfig/findWftPayChannelConfigClrgRulepage';
export const API_wftPayChannel_deletedWftPayChannelConfigClrgRule = HOST + '/platform/wftPayChannelConfig/deletedWftPayChannelConfigClrgRule';
export const API_wftPayChannel_updateWftPayChannelConfigClrgRuleStatus = HOST + '/platform/wftPayChannelConfig/updateWftPayChannelConfigClrgRuleStatus';
export const API_wftPayChannel_getWftPayChannelConfigClrgRuleById = HOST + '/platform/wftPayChannelConfig/getWftPayChannelConfigClrgRule';
export const API_wftPayChannel_updateWftPayChannelConfigClrgRule = HOST + '/platform/wftPayChannelConfig/updateWftPayChannelConfigClrgRule';
export const API_wftPayChannel_addWftPayChannelConfigClrgRule = HOST + '/platform/wftPayChannelConfig/addWftPayChannelConfigClrgRule';
export const API_wftPayChannel_copyWftPayChannelConfigClrgRule = HOST + '/platform/wftPayChannelConfig/copyWftPayChannelConfigClrgRule';
/**
 * @description: 项目控制层
 * 分页；未关联房源的小区/楼栋列表；单个实例；增；编辑；删除；校验项目编号的唯一性
 */
export const API_project_findProjectPageList = HOST + '/platform/project/findProjectPageList';
export const API_project_findBuildingHouseList = HOST + '/platform/project/findBuildingHouseList';
export const API_project_getById = HOST + '/platform/project/getById';
export const API_project_create = HOST + '/platform/project/create';
export const API_project_edit = HOST + '/platform/project/edit';
export const API_project_deleteProject = HOST + '/platform/project/deleteProject';
export const API_project_verifyProject = HOST + '/platform/project/verifyProject';

export const API_project_findProjectListByMerchantId = HOST + '/platform/project/findProjectListByMerchantId';

/**
 * @description: 项目房源控制层
 * 分页；获取单个；编辑；创建
 */
export const API_projecthouse_findPage = HOST + '/platform/projecthouse/findPage';
export const API_projecthouse_getById = HOST + '/platform/projecthouse/getById';
export const API_projecthouse_create = HOST + '/platform/projecthouse/create';
export const API_projecthouse_edit = HOST + '/platform/projecthouse/edit';

/**
 * @description 门店
 */
export const API_salesroom_findPage = HOST + '/platform/ccbProject/findPage'
export const API_salesroom_getById = HOST + '/platform/ccbProject/getById'
export const API_salesroom_create = HOST + '/platform/ccbProject/create'
export const API_salesroom_edit = HOST + '/platform/ccbProject/edit'
export const API_salesroom_delete = HOST + '/platform/ccbProject/delete'
export const API_salesroom_findList = HOST + '/platform/ccbProject/findList'

export const API_device_findList = HOST + '/platform/device/findList'



/**
 * @description: 项目户型
 */

export const API_houseType_findPage = HOST + '/platform/roomType/findPage'
export const API_houseType_getById = HOST + '/platform/roomType/getById'
export const API_houseType_create = HOST + '/platform/roomType/create'
export const API_houseType_edit = HOST + '/platform/roomType/edit'
export const API_houseType_delete = HOST + '/platform/roomType/delete'
export const API_houseType_findList = HOST + '/platform/roomType/findList'
export const API_HOUSEDEVICEINVENTORYBYID = HOST + '/platform/roomType/getHouseDeviceInventoryById'
export const API_CHECKLIST = HOST + '/platform/roomType/checklist'
export const API_GETHOUSEDEVICEBILLBYID = HOST + '/platform/roomType/getHouseDeviceBillById'


export const API_ADDREPAIRSTATE = HOST + '/platform/roomType/addRepairState'


export const API_GETDEVICEBILLWRITEOFFBYID = HOST + '/platform/device/getDeviceBillWriteOffById'

export const API_GETROOMDEVICEBILLBYPROJECTIDANDCYCLEDATE = HOST + '/platform/device/getRoomDeviceBillByProjectIdAndCycleDate'


export const API_GETDEVICEPEPAIRREPORTBYID = HOST + '/platform/roomType/getDevicePepairReportById'

export const API_ADDREPAIRREMARKS = HOST + '/platform/roomType/addRepairRemarks'

export const API_ADDDEVICEREPAIRREMARKS = HOST + '/platform/roomType/addDeviceRepairRemarks'

export const API_roomType_asyncBatchCheck = HOST + '/platform/roomType/asyncBatchCheck'

export const API_roomType_batchGeneration = HOST + '/platform/roomType/batchGeneration'




/**
 * @description: 商户管理 接口
 * 分页；创建商户, 编辑商户, 删除商户, 获取单个商户, 获取所有商户列表, 修改商户 获取验证码 获取商户分账配置
 */
export const API_merchant_findPage = HOST + '/platform/merchant/findPage';
export const API_merchant_create = HOST + '/platform/merchant/create';
export const API_merchant_edit = HOST + '/platform/merchant/edit';
export const API_merchant_delMerchant = HOST + '/platform/merchant/delMerchant';
export const API_merchant_getById = HOST + '/platform/merchant/getById';
export const API_merchant_findAll = HOST + '/platform/merchant/findAll';
export const API_merchant_getSmsCode = HOST + '/platform/merchant/sendBestsignPersonSms';
export const API_merchant_prepCreate = HOST + '/platform/merchant/identifyAndRegisterBestsign' //
export const API_Merchant_getMerchantSplitAccountInfo = HOST+'/platform/merchant/getMerchantSplitAccountInfo';
export const API_Merchant_getMerchantCollectionScheduleCycleInfo= HOST+'/platform/merchantCollectionSchedule/getMerchantCollectionScheduleCycleInfo';
export const API_Merchant_getCycleInfo= HOST+'/platform/merchantCollectionSchedule/getCycleInfo';
export const API_merchant_clearSchedule = HOST + '/platform/merchantCollectionSchedule/clearSchedule';
export const API_Merchant_updateMerchantSplitAccountInfo = HOST+'/platform/merchant/updateMerchantSplitAccountInfo';
export const API_Merchant_updateMerchantCollectionSchedule = HOST+'/platform/merchantCollectionSchedule/update';
export  const API_Merchant_deleteMerchantSplitAccountInfo = HOST+'/platform/merchant/deleteMerchantSplitAccountInfo';
export const API_Merchant_getHsbAccountingRulesList =  HOST+'/platform/merchant/getHsbAccountingRulesList';
export const API_Merchant_findHsbPayChannelConfigAll =  HOST+'/platform/hsbPayChannelConfig/findHsbPayChannelConfigAll';
export const API_Merchant_findWftPayChannelConfigAll =  HOST+'/platform/wftPayChannelConfig/findWftPayChannelConfigAll';
export const API_Merchant_getHsbMerchantInfoList =  HOST+'/platform/merchant/getHsbMerchantInfoList';
export const API_Merchant_getMerchantHsbPayChannelConfigByMerchantId = HOST+'/platform/merchant/getMerchantHsbPayChannelConfigByMerchantId';
export const API_Merchant_updateMerchantHsbPayChannelConfig = HOST+'/platform/merchant/updateMerchantHsbPayChannelConfig';
export const API_Merchant_getCycleList = HOST + '/platform/merchantCollectionSchedule/getCycleList';
export const API_Merchant_getScheduleCycleExpenseDetailsList = HOST + '/platform/merchantCollectionSchedule/getScheduleCycleExpenseDetailsList';
export const API_Merchant_getPeriodicCollectionTotalAmount = HOST + '/platform/merchantCollectionSchedule/getPeriodicCollectionTotalAmount';

/**
 * @description: 管理部门 接口
 * 分页；创建商户部门, 编辑商户部门, 删除商户部门, 获取单个商户部门实例, 获取商户下所有部门
 */
export const API_merchantdepartment_findPage = HOST + '/platform/merchantdepartment/findPage';
export const API_merchantdepartment_create = HOST + '/platform/merchantdepartment/create';
export const API_merchantdepartment_edit = HOST + '/platform/merchantdepartment/edit';
export const API_merchantdepartment_delMerchantDepartment = HOST + '/platform/merchantdepartment/delMerchantDepartment';
export const API_merchantdepartment_getById = HOST + '/platform/merchantdepartment/getById';
export const API_merchantdepartment_findAll = HOST + '/platform/merchantdepartment/findAll';

/**
 * @description: 人员管理 接口
 * 分页；创建商户人员, 编辑商户人员, 删除商户人员, 获取单个商户人员实例；登录；
 */
export const API_merchantuser_findPage = HOST + '/platform/merchantuser/findPage';
export const API_merchantuser_findList = HOST + '/platform/merchantuser/findList';
export const API_merchantuser_create = HOST + '/platform/merchantuser/create';
export const API_merchantuser_edit = HOST + '/platform/merchantuser/edit';
export const API_merchantuser_delMerchantUser = HOST + '/platform/merchantuser/delMerchantUser';
export const API_merchantuser_editMerchantUserStatus = HOST + '/platform/merchantuser/editMerchantUserStatus';
export const API_merchantuser_getById = HOST + '/platform/merchantuser/getById';
export const API_merchantuser_login = HOST + '/platform/merchantuser/login';


/**
 * @description: 角色管理 接口
 * 分页；创建角色, 编辑角色, 删除角色, 获取单个角色实例, 查询所有角色
 */
export const API_role_findPage = HOST + '/platform/role/findPage';
export const API_role_create = HOST + '/platform/role/create';
export const API_role_edit = HOST + '/platform/role/edit';
export const API_role_delRole = HOST + '/platform/role/delRole';
export const API_role_getById = HOST + '/platform/role/getById';
export const API_role_findAll = HOST + '/platform/role/findAll';


/**
 * @description: 平台人员管理 接口
 * 分页；创建人员, 编辑人员, 删除人员, 获取单个人员实例, 检查人员手机号, 登录人员
 */
export const API_employee_findPage = HOST + '/platform/employee/findPage';
export const API_employee_create = HOST + '/platform/employee/create';
export const API_employee_edit = HOST + '/platform/employee/edit';
export const API_employee_delEmployee = HOST + '/platform/employee/delEmployee';
export const API_employee_getById = HOST + '/platform/employee/getById';
export const API_employee_checkPhone = HOST + '/platform/employee/checkPhone';
export const API_employee_login = HOST + '/platform/employee/login';
export const API_employee_findEmployeeList = HOST + '/platform/employee/findEmployeeList' // 人员下拉



/**
 * @description: 平台部门管理 接口
 * 分页；创建人员, 编辑人员, 删除人员, 获取单个人员实例, 部门信息列表
 */
export const API_department_findDepartmentPageList = HOST + '/platform/department/findDepartmentPageList';
export const API_department_create = HOST + '/platform/department/create';
export const API_department_edit = HOST + '/platform/department/edit';
export const API_department_deleteDepartment = HOST + '/platform/department/deleteDepartment';
export const API_department_getById = HOST + '/platform/department/getById';
export const API_department_findDepartmentList = HOST + '/platform/department/findDepartmentList';



/**
 * @description: 商户电子合同模板 接口
 * 分页；创建, 修改, 获取实例
 */
export const API_merchantcontracttemplate_findPage = HOST + '/platform/merchantcontracttemplate/findPage';
export const API_merchantcontracttemplate_create = HOST + '/platform/merchantcontracttemplate/create';
export const API_merchantcontracttemplate_edit = HOST + '/platform/merchantcontracttemplate/edit';
export const API_merchantcontracttemplate_getById = HOST + '/platform/merchantcontracttemplate/getById';


/**
 * @description: 平台人员数据权限 接口
 * 分页；创建, 修改, 获取实例
 */
export const API_employeedataauthority_findPage = HOST + '/platform/employeedataauthority/findPage';
export const API_employeedataauthority_create = HOST + '/platform/employeedataauthority/create';
export const API_employeedataauthority_edit = HOST + '/platform/employeedataauthority/edit';
export const API_employeedataauthority_getById = HOST + '/platform/employeedataauthority/getById';


/**
 * @description: 商户人员数据权限 接口
 * 分页；创建, 修改, 获取实例
 */
export const API_merchantuserdataauthority_findPage = HOST + '/platform/merchantuserdataauthority/findPage';
export const API_merchantuserdataauthority_create = HOST + '/platform/merchantuserdataauthority/create';
export const API_merchantuserdataauthority_edit = HOST + '/platform/merchantuserdataauthority/edit';
export const API_merchantuserdataauthority_getById = HOST + '/platform/merchantuserdataauthority/getById';


/**
 * @description: 角色权限 接口
 * 分页；创建, 修改, 获取实例
 */
export const API_roleauthority_findPage = HOST + '/platform/roleauthority/findPage';
export const API_roleauthority_create = HOST + '/platform/roleauthority/create';
export const API_roleauthority_edit = HOST + '/platform/roleauthority/edit';
export const API_roleauthority_getById = HOST + '/platform/roleauthority/getById';


/**
 * @description: 系统预定义电子合同模板 接口；根据房源id获取被关联的合同
 */
export const API_contracttemplate_findAllContractTemplate = HOST + '/platform/contracttemplate/findAllContractTemplate';
export const API_contracttemplate_findByHouseId = HOST + '/platform/contracttemplate/findByHouseId';


/**
 * @description: 【商户/平台人员】数据权限 接口
 */
export const API_merchantuserdataauthority_findBuildingAndHouse = HOST + '/platform/merchantuserdataauthority/findBuildingAndHouse';
export const API_merchantuserdataauthority_findNewsBuildingAndHouse = HOST + '/platform/merchantuserdataauthority/findNewsBuildingAndHouse';
export const API_employeedataauthority_findMerchantAndProject = HOST + '/platform/employeedataauthority/findMerchantAndProject';


/**
 * @description: 系统预定义电子合同模板 接口
 */
export const API_authoritypoint_findAllBySelected = HOST + '/platform/authoritypoint/findAllBySelected';


/**
 * @description: 【商户/平台人员】修改密码 接口
 * 修改密码
 */
export const API_employee_modifyPassword = HOST + '/platform/employee/modifyPassword';
export const API_employee_modifyPayPassword = HOST + '/platform/employee/modifyPayPassword';
export const API_merchantuser_modifyPassword = HOST + '/platform/merchantuser/modifyPassword';



/**
 * @description: 租赁合同 接口
 * 分页，导出，下载模板, 获取合同金额和合同总是, 短信发送， 获取详情, 章党详情， 退租 ，修改
 */
export const API_rentcontract_findRentContractPageList = HOST + '/platform/rentcontract/findRentContractPageList';
export const API_rentcontract_findExpireRentContractPageList=HOST + '/platform/rentcontract/findExpireRentContractPageList';
export const API_rentcontract_rentContractExprotDate = HOST + '/platform/rentcontract/rentContractExprotDate';
export const API_rentcontract_rentContractImportTemplate = HOST + '/platform/rentcontract/rentContractImportTemplate';
export const API_rentcontract_create = HOST + '/platform/rentcontract/create';
export const API_rentcontract_edit = HOST + '/platform/rentcontract/edit';
export const API_rentcontract_findRentContractCount = HOST + '/platform/rentcontract/findRentContractCount';
export const API_rentcontract_findExpireRentContractCount = HOST + '/platform/rentcontract/findExpireRentContractCount';

export const API_rentcontract_rentContractSendSms = HOST + '/platform/rentcontract/rentContractSendSms';
export const API_rentcontract_getRentContractById = HOST + '/platform/rentcontract/getRentContractById';
export const API_rentcontract_getRentContractByIdBillMsg = HOST + '/platform/rentcontract/getRentContractByIdBillMsg';    //详情 -> 账单信息
export const API_rentcontract_getRentContractByIdEndMsg = HOST + '/platform/rentcontract/getRentContractByIdEndMsg';   //详情 -> 退租信息
export const API_rentcontract_getRentContractByIdTradeRecordMsg = HOST + '/platform/rentcontract/getRentContractByIdTradeRecordMsg';
export const API_rentcontract_getRentContractByIdUserMsg = HOST + '/platform/rentcontract/getRentContractByIdUserMsg';
export const API_rentcontract_endContract = HOST + '/platform/rentcontract/endContract';
export const API_rentcontract_getEndVo = HOST + '/platform/rentcontract/getEndVo';
export const API_rentcontract_getReceivableBillList = HOST + '/platform/rentcontract/getReceivableBillList';
export const API_rentcontract_editRentContractMsg = HOST + '/platform/customer/editRentContractMsg'
export const API_rentcontract_delete = HOST + '/platform/rentcontract/delete';
export const API_rentcontract_getMerchantSignUrl = HOST + '/platform/rentcontract/getMerchantSignUrl';
export const API_rentcontract_getPreviewUrl = HOST + '/platform/rentcontract/getPreviewUrl';
export const API_rentcontract_getContractFileUrl = HOST + '/platform/rentcontract/getContractFileUrl';
export const API_rentcontract_sendSignSms = HOST + '/platform/rentcontract/sendSignSms';
export const API_rentcontract_importRentContract = HOST + '/platform/rentcontract/importRentContract';
export const API_rentcontract_getImportLog = HOST + '/platform/rentcontract/getImportLog';  //getImportLog#获取批量导入合同的异步进程日志

/**
 * @description: 附件上传 接口
 */
export const API_upload_upload_file = HOST + '/platform/upload/upload_file';
export const API_upload_uploadContractFile = HOST + '/platform/upload/uploadContractFile';  //上传合同附件

/**
 * @description 获取附件 接口
 */
export const API_attach_list = HOST + '/platform/attach/findPage'

/**
 * @description: 操作记录 接口
 */
export const API_operationlog_findPage = HOST + '/platform/operationlog/findPage';
export const API_operationlog_findOperationLogListPage = HOST + '/platform/operationlog/findOperationLogListPage';

/**
 * @description: 房间物品 接口
 */
export const API_rentcontractfurniture_findPage = HOST + '/platform/rentcontractfurniture/findPage';
export const API_rentcontractfurniture_getById = HOST + '/platform/rentcontractfurniture/getById';
export const API_rentcontractfurniture_create = HOST + '/platform/rentcontractfurniture/create';
export const API_rentcontractfurniture_edit = HOST + '/platform/rentcontractfurniture/edit';

/**
 * @description: 收付流水 接口
 * 分页；单个实例， 创建， 编辑， 导出s~
 */
export const API_traderecord_findPage = HOST + '/platform/traderecord/findPage';
export const API_traderecord_getById = HOST + '/platform/traderecord/getById';
export const API_traderecord_create = HOST + '/platform/traderecord/create';
export const API_traderecord_edit = HOST + '/platform/traderecord/edit';
export const API_traderecord_tradeRecordExprot = HOST + '/platform/traderecord/tradeRecordExprot';
export const API_traderecord_transferRecordExprot = HOST + '/platform/traderecord/transferRecordExprot';
export const API_traderecord_getTotalMoney = HOST + '/platform/traderecord/getTotalMoney';
export const API_traderecord_getDiscountTotalMoney = HOST + '/platform/traderecord/getDiscountTotalMoney';




export const API_traderecordoffline_add = HOST + '/platform/traderecordoffline/add';
export const API_traderecordoffline_transferRecordExprot = HOST + '/platform/traderecordoffline/transferRecordExprot';
export const API_traderecordoffline_findPage = HOST + '/platform/traderecordoffline/findPage';
export const API_traderecordoffline_check = HOST + '/platform/traderecordoffline/check';
export const API_traderecordoffline_getById = HOST + '/platform/traderecordoffline/getById';
export const API_traderecordoffline_getTotalMoney = HOST + '/platform/traderecordoffline/getTotalMoney';


export const API_device_writeOffAdd = HOST + '/platform/device/writeOffAdd';


/**
 * @description: 短信发送明细
 * 分页
 */
export const API_smslog_findPage = HOST + '/platform/smslog/findPage'; //分页
export const API_smslog_smslogExprot = HOST + '/platform/smslog/smslogExprot'; //分页


/**
 * @description: 建融家园接口日志
 * 分页
 */
export const API_jrapilog_findPage = HOST + '/platform/apilog/findJrApiLogPage'; //分页


/**
 * @description: 建融家园接口报警日志日志
 * 分页
 */
export const API_jrWarning_findPage = HOST + '/platform/warning/findPage'; //分页
export const API_jrWarningStatus_check = HOST + '/platform/warning/updateStatus';//报警数据状态处理
export const API_jrWarningStatusAll_check = HOST + '/platform/warning/updateStatusAll';//报警数据状态处理


/**
 * @description: 统计报表
 */
export const API_report_findReportTradeRecordPage = HOST + '/platform/report/findNewsReportTradeRecordPage'; //列表
export const API_report_findReportTradeRecordInfo = HOST + '/platform/report/findNewsReportTradeRecordInfo'; //详情
export const API_report_reportTradeRecordInfoExprotDate = HOST + '/platform/report/reportTradeRecordInfoNewsExprotDate'; //导出详情
export const API_report_tradeRecordListExprotDate = HOST + '/platform/report/tradeRecordListNewsExprotDate'; //导出列表
export const API_report_roomTypeDownload = HOST + '/platform/roomType/download'; //导出列表
export const API_report_roomTypeDownloadExcel = HOST + '/platform/roomType/downloadExcel'; //导出列表
export const API_verify_findHsbPayOrderSplitAccountSumPage = HOST + '/platform/verify/findHsbPayOrderSplitAccountSumPage'; //列表
export const API_report_deviceRepairReportExprotDateExcel = HOST + '/platform/roomType/deviceRepairReportExprotDate'; //导出列表
export const API_report_findHouseBillExprot = HOST + '/platform/house/findHouseBillExprot'; //设备账单导出列表

export const API_report_deviceImportDeviceBillTemplate = HOST + '/platform/device/getImportDeviceBillTemplate'; //导出列表
export const API_report_deviceImportAcceptanceTemplate = HOST + '/platform/device/getImportAcceptanceTemplate'; //导出列表


export const API_device_findReportTradeRecordPage = HOST + '/platform/device/findDeviceNewsReportTradeRecordPage'; //列表
export const API_device_tradeRecordListExprotDate = HOST + '/platform/device/tradeRecordListNewsExprotDate'; //导出列表

/**
 * @description: 数据字典
 */
export const API_dictionary_findPage = HOST + '/platform/dictionary/findPage'; //数据字典
export const API_dictionary_findList = HOST + '/platform/dictionary/findList'; //数据字典

/**
 * @description: 渠道客户
 */
export const API_channelCustomer_findPage = HOST + '/platform/channelCustomer/findPage'; // 列表查询
export const API_channelCustomer_getById = HOST + '/platform/channelCustomer/getById'; // 详情


/**
 * @description: 渠道
 */
export const API_channel_add = HOST + '/platform/channel/add'; // 添加
export const API_channel_findPage = HOST + '/platform/channel/findPage'; // 列表查询
export const API_channel_getToken = HOST + '/platform/channel/getChannelToken'; // 获取唯一 token
export const API_channel_getUrl = HOST + '/platform/channel/getChannelUrl'; // 获取渠道页面地址
export const API_channel_update = HOST + '/platform/channel/update'; // 修改渠道
export const API_channel_updateStatus = HOST + '/platform/channel/updateChannelStatus'; // 修改渠道状态
export const API_channel_findList = HOST + '/platform/channel/findList'; // 渠道下拉


/**
 * @description: 接口日志
 */
export const API_apilog_findPage = HOST + '/platform/apilog/findPage' // 查询


/**
 * @description: 合同模板
 */
export const API_contracttemplate_findPage = HOST + '/platform/contracttemplate/findPage' // 查询
export const API_contracttemplate_edit = HOST + '/platform/contracttemplate/edit' // 修改
export const API_contracttemplate_create = HOST + '/platform/contracttemplate/create' // 新建
export const API_contracttemplate_getById = HOST + '/platform/contracttemplate/getContractTemplateInfoById' // 详情

//
export const API_upload_file_jr = HOST + '/platform/upload/jr_upload_file'


// WEBPACK FOOTER //
// ./src/axios/config.js